var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgNoDataIcon = function SvgNoDataIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "black",
    fillOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.0949 28.3057H32.5037L35.4788 31.2808H52.0949V47.8969L54.713 50.515C54.9362 50.0985 55.0701 49.6374 55.0701 49.1316V31.2808C55.0701 29.6445 53.7312 28.3057 52.0949 28.3057Z",
    fill: "black",
    fillOpacity: 0.26
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1197 37.2314H41.429L44.4041 40.2066H49.1197V37.2314Z",
    fill: "black",
    fillOpacity: 0.26
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8904 28.1123L25.6755 29.8974C25.4523 30.3139 25.3184 30.7751 25.3184 31.2809V49.1317C25.3184 50.768 26.6573 52.1068 28.2936 52.1068H47.8848L52.288 56.51L54.3855 54.4125L25.9879 26L23.8904 28.1123ZM28.2936 32.5155L33.0092 37.2311H31.2687V40.2063H34.2438V38.4658L38.9594 43.1814H31.2687V46.1565H41.9346L44.9097 49.1317H28.2936V32.5155Z",
    fill: "black",
    fillOpacity: 0.26
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNoDataIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "no-data-icon.fbfe8fc5bf40518003f2af360e5e2080.svg";